module.exports = __webpack_public_path__ + "img/bg3.6dd710a5.png";